import React from 'react';
import { add, format } from 'date-fns';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

import { DatePicker } from '@atlaskit/datetime-picker';
import { useIntl } from 'react-intl';
import { useAppContext } from '../context/AppContext';
import { ShowMainTransactionDataFormViewInput } from './ShowMainTransactionDataFormView';

type Props = {
    control: Control<ShowMainTransactionDataFormViewInput, object>;
    name: string;
    rules:  Omit<RegisterOptions<ShowMainTransactionDataFormViewInput, "transactionDate">, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"> | undefined;
};

const TransactionDateDatePicker = ({ control, name, rules }: Props) => {
    const currentLanguage = useAppContext();
    const dateNow: Date = new Date();
    const threeMonthsAgo: Date = add(dateNow, { months: -3 });
    const intl = useIntl();
    return (
        <div className="datePicker">
            <Controller
                name="transactionDate"
                control={control}
                rules={rules}
                render={({ field: { ref, disabled, ...field } }) => (
                    <DatePicker
                        id="date-picker-input"
                        {...field}
                        onChange={(date) => {
                            field.onChange(date);
                        }}
                        dateFormat="DD/MM/YYYY"
                        value={field.value ? field.value : ''}
                        weekStartDay={1}
                        placeholder={intl.formatMessage({ id: 'selectDate.placeholder' })}
                        locale={currentLanguage.language}
                        name={name}
                        minDate={format(threeMonthsAgo, 'yyyy-MM-dd')}
                        maxDate={format(dateNow, 'yyyy-MM-dd')}
                        selectProps={{ weekStartDay: 1 }}
                    />
                )}
            />
        </div>
    );
};

export default TransactionDateDatePicker;
